import { Box } from "@mui/material";

type DocumentDrawerComponentProps = {
    handleClose: (open: boolean) => () => void;
}

const DocumentDrawerComponent: React.FC<DocumentDrawerComponentProps> = ({handleClose}) => {

    return (
        <Box>    
            {/* {drawer.name === 'Document Activity' && <ActivityLog />}        */}
            {/* {drawer.name === 'Earnings' && <EarningComponent />}
            {drawer.name === 'Deductions' && <DeductionComponent />} */}
        </Box>
    )
}
export default DocumentDrawerComponent